// Wspólne reguły wyglądu panelu Subiekta - lista, szczegóły i podgląd pozycji muszą
// mówić o tym samym dokumencie tym samym językiem. Wcześniej każdy komponent miał
// własną kopię i ten sam dokument bywał w jednym miejscu „szkicem", a w innym
// „czeka na potwierdzenie".

// Kolor typu niesie kierunek ruchu towaru: WZ zdejmuje ze stanu, PZ dokłada,
// PW/RW/MM to ruch wewnętrzny.
export function typeBadge(action) {
  if (action === 'WZ') return 'bg-blue-100 text-blue-700';
  if (action === 'PZ') return 'bg-green-100 text-green-700';
  if (action === 'PW') return 'bg-purple-100 text-purple-700';
  if (action === 'FZ') return 'bg-yellow-100 text-yellow-800';
  return 'bg-gray-100 text-gray-700';
}

export function contractorName(doc) {
  return (doc && doc.kontrahent && doc.kontrahent.nazwa) || (doc && doc.symbolKontrahenta) || '—';
}

// "B4203 ×2, B4608 ×2" - ten sam format, który most wpisuje do „Uwag" dokumentu.
export function shortageText(doc) {
  const shortages = Array.isArray(doc && doc.braki) ? doc.braki : [];
  return shortages
    .map(item => `${item.symbolTowaru} ×${Math.ceil(Number(item.potrzeba) - Number(item.stan))}`)
    .join(', ');
}

// Jeden stan dokumentu dla całego panelu. Kolejność warunków ma znaczenie:
// status z bazy wygrywa z blokadami, bo dokument w kolejce nie jest już edytowany.
const STRIPES = {
  done: 'border-green-500', queued: 'border-blue-500', error: 'border-red-500',
  blocked: 'border-yellow-400', ready: 'border-indigo-500', other: 'border-gray-300',
};

// Pasek przy wierszu w kolorze stanu - patrz STRIPES.
export function subiektStatus(doc) {
  const result = statusCore(doc);
  return { ...result, stripe: STRIPES[result.key] || 'border-gray-300' };
}

function statusCore(doc) {
  const status = (doc && doc.status) || 'SZKIC';
  const job = (doc && doc.zadanie) || {};

  if (status === 'WYSTAWIONY') {
    const number = doc.subiekt && doc.subiekt.numer;
    return {
      key: 'done',
      text: number || 'Wystawiony',
      badge: 'bg-green-500 text-white',
      tooltip: number ? `Wystawiony w Subiekcie jako ${number}` : 'Wystawiony w Subiekcie',
    };
  }
  if (status === 'W_TRAKCIE') {
    return {
      key: 'queued',
      text: 'Wystawianie…',
      badge: 'bg-blue-600 text-white',
      spin: true,
      tooltip: 'Most właśnie wystawia dokument w Subiekcie',
    };
  }
  if (status === 'WYSLANY') {
    if (job.klucz == null) {
      return {
        key: 'queued',
        text: 'Wysłany (stary most)',
        badge: 'bg-gray-400 text-white',
        tooltip: 'Wysłany poprzednią wersją mostu. Sprawdź w Subiekcie i oznacz jako wystawiony albo cofnij.',
      };
    }
    // Faktura zakupu też ma „czekaNa" (swoją PZ), ale powstaje dopiero, gdy PZ jest
    // wystawiona - więc w kolejce na nic już nie czeka.
    if (doc.czekaNa && doc.action !== 'FZ') {
      return {
        key: 'queued',
        text: 'Czeka na PW',
        badge: 'bg-blue-400 text-white',
        tooltip: 'Most wystawi go po przyjęciu na braki, od którego zależy',
      };
    }
    if (Number(job.proby) > 0) {
      return {
        key: 'queued',
        text: `Ponowienie ${job.proby}/5`,
        badge: 'bg-blue-500 text-white',
        tooltip: job.ostatniBlad ? `Ostatnia próba: ${job.ostatniBlad}` : 'Most ponowi próbę',
      };
    }
    return {
      key: 'queued',
      text: 'W kolejce',
      badge: 'bg-blue-500 text-white',
      tooltip: 'Czeka na most — zwykle do minuty',
    };
  }
  if (doc && doc.tylkoPorownanie) {
    return { key: 'other', text: 'Do porównania', badge: 'bg-gray-200 text-gray-700', tooltip: 'Nie jest wysyłany do Subiekta' };
  }
  if (doc && doc.blad) {
    return { key: 'error', text: 'Błąd wysyłki', badge: 'bg-red-500 text-white', tooltip: doc.blad };
  }
  if (Array.isArray(doc && doc.blokady) && doc.blokady.length > 0) {
    return { key: 'blocked', text: 'Do uzupełnienia', badge: 'bg-yellow-400 text-white', tooltip: doc.blokady.join(' ') };
  }
  return { key: 'ready', text: 'Gotowy', badge: 'bg-indigo-100 text-indigo-700', tooltip: 'Gotowy do wysłania' };
}
